import React from 'react';
import FredModal from 'components/Fred/FredModal';
import FredController from './controllers/FredController';
import { createRoot } from 'react-dom/client';

/**
 * @typedef AskFredAnythingArgs
 * @prop {string=} initialTab
 * @prop {string=} initialCommand
 * @prop {string=} initialCommandArgs
 * @prop {function=} callback
 * @prop {boolean=} eventsOnly
 */

/**
 * @type {(args: AskFredAnythingArgs) => Promise<void>}
 */
const askFredAnything = async ({
  initialTab,
  initialCommand,
  initialCommandArgs,
  callback,
  eventsOnly,
}) => {
  // Don't open the modal again if it is already open.
  if (document.getElementsByClassName('fred-modal').length > 0) {
    if (initialCommand && window.commandController) {
      // If we are already executing a command, allow reentry into command
      // execution.
      await window.commandController.actionExecuteCommandByIdentifier(
        initialCommand,
        initialCommandArgs,
        callback
      );
    }
    return;
  }

  if (initialCommand) {
    initialTab = FredController.TAB_COMMANDS;
  }

  const modal = document.createElement('div');
  modal.className = 'react-modal-container';
  document.body.appendChild(modal);
  const root = createRoot(modal);

  const close = function () {
    // Give close animation a chance to finish.
    setTimeout(() => {
      root.unmount();
      modal.parentNode && modal.parentNode.removeChild(modal);
    }, 500);
  };

  trackUserOpensGlobalSearch();

  return root.render(
    <FredModal
      onClose={close}
      initialTab={initialTab}
      initialCommand={initialCommand}
      initialCommandArgs={initialCommandArgs}
      callback={callback}
      eventsOnly={eventsOnly}
    />
  );
};

function trackUserOpensGlobalSearch() {
  window.AhaAnalytics?.track(
    'Feature-7412685970609879824',
    'Global search - User opens search'
  );
}

export default askFredAnything;
